export class Amount {
  value: number;
  currency: string;
  estEstime: boolean;

  constructor(value: number, currency: string, estEstime: boolean) {
    this.value = value;
    this.currency = currency;
    this.estEstime = estEstime;
  }
}
